import { SxProps } from "@mui/material";

export const sxInput: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
	width: '100%',
  '@media (max-width: 768px)': {
    maxWidth: 'unset'
  },
  '@media (min-width: 768px) and (max-width: 899px)': {
    minWidth: '400px'
  }
}

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxCloseIconButton: SxProps = {
	position: 'absolute',
	right: '24px',
	top: '24px',
	color: '#383838',
	'@media(max-width: 650px)': {
			right: '16px',
			top: '12px'
	}
}

export const sxModal: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	bgcolor: '#fff',
	borderRadius: '16px',
	border: 'none',
	boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
	padding: '32px 48px',
	gap: '24px',
	overflow: 'auto',
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'center',
	alignItems: 'center',
	width: '650px',
	'@media(max-width: 700px)': {
		width: '80%'
	}
}

export const sxButtons: SxProps = {
	width: '100%',
	display: 'flex',
	justifyContent: 'space-between',
	marginTop: '12px',
	'@media(max-width: 700px)': {
		flexDirection: 'column',
		gap: '10px',
	}
}